import axios from 'axios'
import moment from 'moment'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function getCenterPeopleTotalFlow(condition = {}) {
  let response = {}

  let startTime = condition.startTime? encodeURIComponent(moment(condition.startTime).format().split('+')[0]) : null //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `?startTime=${startTime}` : ''
  let endTime = condition.endTime?  encodeURIComponent(moment(condition.endTime).format().split('+')[0]) : null//2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery = endTime ? `&endtime=${endTime}` : ''
  //沒有起訖時間則預設為今日

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}CenterPeopleFlow/GetCenterPeopleTotalFlow${startTimeQuery}${endTimeQuery}`)

  } catch (err) {
    console.error('iisi GetCenterPeopleTotalFlow: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}

export async function getCenterPeopleFlowList(condition = {}) {
  let response = {}

  let scenicAreaId = condition.id // 沒有景區id則是全部
  let scenicAreaIdQuery = scenicAreaId? `?scenicAreaId=${scenicAreaId}` : '' 
  let startTime = condition.startTime? encodeURIComponent(moment(condition.startTime).format().split('+')[0]) : null //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? Utils.isEmptyString(scenicAreaIdQuery) ? `?startTime=${startTime}` : `&startTime=${startTime}` : ''
  let endTime = condition.endTime?  encodeURIComponent(moment(condition.endTime).format().split('+')[0]) : null//2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery = endTime ? `&endtime=${endTime}` : ''
  //沒有起訖時間則預設為今日

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}CenterPeopleFlow/GetCenterPeopleFlowList${scenicAreaIdQuery}${startTimeQuery}${endTimeQuery}`)

  } catch (err) {
    console.error('iisi getCenterPeopleFlowList: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}